import * as React from 'react';
import { ArrowDownLine, ArrowUpLine, SubtractLine } from '@mingcute/react';

import { cn } from '../lib/cn';

export interface StatCardProps extends React.HTMLAttributes<HTMLDivElement> {
  label: string;
  value: React.ReactNode;
  delta?: string;
  deltaDir?: 'up' | 'down' | 'flat';
  deltaLabel?: string;
  icon?: React.ReactNode;
}

export const StatCard = React.forwardRef<HTMLDivElement, StatCardProps>(
  ({ label, value, delta, deltaDir = 'up', deltaLabel, icon, className, ...props }, ref) => {
    const deltaColor =
      deltaDir === 'up'
        ? 'text-[var(--color-success)]'
        : deltaDir === 'down'
          ? 'text-[var(--color-danger)]'
          : 'text-[var(--color-fg-muted)]';
    const DeltaIcon = deltaDir === 'up' ? ArrowUpLine : deltaDir === 'down' ? ArrowDownLine : SubtractLine;

    return (
      <div
        ref={ref}
        className={cn(
          'flex flex-col gap-1.5 min-w-[140px] rounded-xl border px-5 py-4',
          'bg-[var(--color-surface)] border-[var(--color-border)]',
          className,
        )}
        {...props}
      >
        <div className="flex items-start justify-between gap-2">
          <span className="text-[11px] font-medium uppercase tracking-wider text-[var(--color-fg-muted)]">
            {label}
          </span>
          {icon && <span className="text-[var(--color-fg-muted)]">{icon}</span>}
        </div>
        <div className="text-[28px] font-bold leading-none text-[var(--color-fg)]">{value}</div>
        {delta && (
          <div className={cn('flex items-center gap-1 text-xs', deltaColor)}>
            <DeltaIcon size={12} />
            <span className="font-semibold">{delta}</span>
            {deltaLabel && (
              <span className="text-[var(--color-fg-muted)] font-normal">{deltaLabel}</span>
            )}
          </div>
        )}
      </div>
    );
  },
);
StatCard.displayName = 'StatCard';
